<div class="title">Hint</div>
<div class="hint">{{ hint }}</div>
